import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { withClientOnly } from 'app/helpers/hydration'

const TextBlock = React.lazy(() => import('app/components/CustomBlocks/component/TextBlock'))
const WPGImageBlock = React.lazy(() => import('app/components/CustomBlocks/component/Image'))
const ButtonBlock = React.lazy(() => import('app/components/CustomBlocks/component/ButtonBlock'))
const ContainerBlock = React.lazy(() => import('app/components/CustomBlocks/layout/ContainerBlock'))
const SectionBlock = React.lazy(() => import('app/components/CustomBlocks/layout/SectionBlock'))
const TwoSideLayoutBlock = React.lazy(() => import('app/components/CustomBlocks/layout/TwoSideLayoutBlock'))
const BackgroundBlock = React.lazy(() => import('app/components/CustomBlocks/layout/BackgroundBlock'))
const LogoBlock = React.lazy(() => import('app/components/CustomBlocks/Icon/LogoBlock'))
const ValuePropositionBlock = React.lazy(() => import('app/components/CustomBlocks/layout/ValuePropositionBlock'))
const ValuePropositionListBlock = React.lazy(
  () => import('app/components/CustomBlocks/layout/ValuePropositionListBlock'),
)
const ComponentListItemBlock = React.lazy(() => import('app/components/CustomBlocks/layout/ComponentListItemBlock'))
const InfoWithExpandableCardsSectionBlockV2 = React.lazy(
  () => import('app/components/CustomBlocks/Section/InfoWithExpandableCardsSectionBlock'),
)
const CardWithAuthorBlock = React.lazy(() => import('app/components/CustomBlocks/component/CardWithAuthorBlock'))
const InfoBlock = React.lazy(() => import('app/components/CustomBlocks/component/InfoBlock'))
const InfoBlockList = React.lazy(() => import('app/components/CustomBlocks/layout/InfoBlockList'))
const FAQSectionBlock = React.lazy(() => import('app/components/CustomBlocks/Section/FAQSectionBlock'))
const OpenableCardBlock = React.lazy(() => import('app/components/CustomBlocks/component/OpenableCardBlock'))
const BottomCTASectionBlock = React.lazy(() => import('app/components/CustomBlocks/Section/BottomCTASectionBlock'))
const CardsSetBlock = React.lazy(() => import('app/components/CustomBlocks/Section/CardsSetBlock'))
const ClickableSmallCardsBlock = React.lazy(
  () => import('app/components/CustomBlocks/Section/ClickableSmallCardsBlock'),
)
const FeatureCardsSetBlock = React.lazy(() => import('app/components/CustomBlocks/Section/FeatureCardsSetBlock'))
const ClickableFeatureCardsSetBlock = React.lazy(
  () => import('app/components/CustomBlocks/Section/FeatureCardsSetBlock'),
)
const StepsBlock = React.lazy(() => import('app/components/CustomBlocks/Section/StepsBlock'))
const InfoWithImageBlock = React.lazy(() => import('app/components/CustomBlocks/Section/InfoWithImageBlock'))
const CustomerReviewsBlock = React.lazy(() => import('app/components/CustomBlocks/Section/CustomerReviewsBlock'))
const FAQBlock = React.lazy(() => import('app/components/CustomBlocks/Section/FAQBlock'))
const ColoredBackgroundLayoutBlock = React.lazy(
  () => import('app/components/CustomBlocks/layout/ColoredBackgroundLayoutBlock'),
)
const HeroLayoutBlock = React.lazy(() => import('app/components/CustomBlocks/layout/HeroLayoutBlock'))
const OsDownloadButtonBlock = React.lazy(() => import('app/components/CustomBlocks/component/OsDownloadButtonBlock'))
const CardBlock = React.lazy(() => import('app/components/CustomBlocks/component/CardBlock'))
const CardRowLayoutBlock = React.lazy(() => import('app/components/CustomBlocks/layout/CardRowLayoutBlock'))
const AppleIconBlock = React.lazy(() => import('app/components/CustomBlocks/Icon/AppleIconBlock'))
const WindowsIconBlock = React.lazy(() => import('app/components/CustomBlocks/Icon/WindowsIconBlock'))
const AndroidIconBlock = React.lazy(() => import('app/components/CustomBlocks/Icon/AndroidIconBlock'))
const IllustrationWithTextLayoutBlock = React.lazy(
  () => import('app/components/CustomBlocks/layout/IllustrationWithTextLayoutBlock'),
)
const SmileClipboardIllustrationBlock = React.lazy(
  () => import('app/components/CustomBlocks/illustrations/SmileClipboardIllustrationBlock'),
)
const WPGColumnsBlock = React.lazy(() => import('app/components/CustomBlocks/layout/WPGColumnsBlock'))
const ShortcodeBlock = React.lazy(() => import('app/components/CustomBlocks/component/ShortcodeBlock'))
const AnchorTagBlock = React.lazy(() => import('app/components/CustomBlocks/component/AnchorTagBlock'))
const CenteredBlocksListBlock = React.lazy(() => import('app/components/CustomBlocks/layout/CenteredBlocksListBlock'))
const GroupBlock = React.lazy(() => import('app/components/CustomBlocks/layout/GroupBlock'))
const HeroBackgroundLayoutBlock = React.lazy(
  () => import('app/components/CustomBlocks/layout/HeroBackgroundLayoutBlock'),
)
const SequenceLayoutItemBlock = React.lazy(() => import('app/components/CustomBlocks/layout/SequenceLayoutItemBlock'))
const SequenceLayoutBlock = React.lazy(() => import('app/components/CustomBlocks/layout/SequenceLayoutBlock'))
const HomepageHeroSectionBlock = React.lazy(
  () => import('app/components/CustomBlocks/Section/HomepageHeroSectionBlock'),
)
const HeroBlock = React.lazy(() => import('app/components/CustomBlocks/Section/HeroBlock'))
const PopupBlock = React.lazy(() => import('app/components/CustomBlocks/Section/PopupBlock'))
const CalculatorBlock = React.lazy(() => import('app/components/CustomBlocks/Section/CalculatorBlock'))
const StatsBlock = React.lazy(() => import('app/components/CustomBlocks/Section/StatsBlock'))
const StatisticsBlock = React.lazy(() => import('app/components/CustomBlocks/Section/StatisticsBlock'))
const StatisticsGridBlock = React.lazy(() => import('app/components/CustomBlocks/Section/StatisticsGridBlock'))
const TestimonialsBlock = React.lazy(() => import('app/components/CustomBlocks/Section/TestimonialsBlock'))
const HeroCenteredBlock = React.lazy(() => import('app/components/CustomBlocks/Section/HeroCenteredBlock'))
const BigHeadlineBlock = React.lazy(() => import('app/components/CustomBlocks/Section/BigHeadlineBlock'))
const TrustpilotWidget = React.lazy(
  () => import('app/components/CustomBlocks/component/TrustpilotWidget/TrustpilotWidget'),
)
const SignupCampaignBlock = React.lazy(() => import('app/components/SignupCampaign/SignupCampaignBlock'))
const InfoCardBlock = React.lazy(() => import('app/components/CustomBlocks/component/InfoCardBlock'))
const InfoCardCompactBlock = React.lazy(() => import('app/components/CustomBlocks/component/InfoCardCompactBlock'))
const FeatureCardRowBlock = React.lazy(() => import('app/components/CustomBlocks/component/FeatureCardRowBlock'))
const LogosBlock = React.lazy(() => import('app/components/CustomBlocks/Section/LogosBlock'))
const VideoReviewsBlock = React.lazy(() => import('app/components/CustomBlocks/Section/VideoReviewsBlock'))
const PromoBlock = React.lazy(() => import('app/components/CustomBlocks/Section/PromoBlock'))
const SocialsBlock = React.lazy(() => import('app/components/CustomBlocks/Section/SocialsBlock'))
const InfoWithBulletPointsBlock = React.lazy(
  () => import('app/components/CustomBlocks/Section/InfoWithBulletPointsBlock'),
)
const InfoWithVideoGallerySectionBlock = React.lazy(
  () => import('app/components/CustomBlocks/Section/InfoWithVideoGallerySectionBlock'),
)
const GallerySectionBlock = React.lazy(() => import('app/components/CustomBlocks/Section/GallerySectionBlock'))
const GalleryWithInfoSectionBlock = React.lazy(
  () => import('app/components/CustomBlocks/Section/GalleryWithInfoSectionBlock'),
)
const HeadingWithContext = React.lazy(() => import('app/components/CustomBlocks/Section/HeadingWithContext'))
const HeadingWithImage = React.lazy(() => import('app/components/CustomBlocks/Section/HeadingWithImage'))
const ClickableFeatureCardRowBlock = React.lazy(
  () => import('app/components/CustomBlocks/component/ClickableFeatureCardRowBlock'),
)
const HelloBarBlock = React.lazy(() => import('app/components/CustomBlocks/component/HelloBarBlock'))
const PromoBannerBlock = React.lazy(() => import('app/components/blog/PromoBanner/PromoBannerBlock'))
const WPGListBlock = React.lazy(() => import('app/components/CustomBlocks/layout/WPGListBlock'))
const WPGParagraphBlock = React.lazy(() => import('app/components/CustomBlocks/layout/WPGParagraphBlock'))

const BlogListBlock = React.lazy(() => import('app/components/CustomBlocks/blog/BlogListBlock'))
const BlogParagraphBlock = React.lazy(() => import('app/components/CustomBlocks/blog/BlogParagraphBlock'))
const BlogHeadingBlock = React.lazy(() => import('app/components/CustomBlocks/blog/BlogHeadingBlock'))
const BlogImageBlock = React.lazy(() => import('app/components/CustomBlocks/blog/BlogImageBlock'))

const GrowthbookExperimentBlock = React.lazy(
  () => import('app/components/CustomBlocks/utils/GrowthbookExperimentBlock'),
)
const GrowthbookVariantBlock = React.lazy(() => import('app/components/CustomBlocks/utils/GrowthbookVariantBlock'))

type Registry = Record<string, React.FC<IWPGBlock>>

const registry: Registry = {
  // ICONS
  'honeygain-illustrations/smile-clipboard': SmileClipboardIllustrationBlock,
  'honeygain-icons/logo': LogoBlock,
  'honeygain-icons/apple-icon': AppleIconBlock,
  'honeygain-icons/windows-icon': WindowsIconBlock,
  'honeygain-icons/android-icon': AndroidIconBlock,
  // COMPONENTS
  'honeygain-components/card-with-author': CardWithAuthorBlock,
  'honeygain-components/info-block': InfoBlock,
  'honeygain-components/openable-card': OpenableCardBlock,
  'honeygain-components/card': CardBlock,
  'honeygain-components/os-download-button': OsDownloadButtonBlock,
  'honeygain-components/button': ButtonBlock,
  'honeygain-components/anchor-tag': AnchorTagBlock,
  'honeygain-components/trustpilot-widget': TrustpilotWidget,
  'honeygain-components/signup-campaign': SignupCampaignBlock,
  'honeygain-components/promo-banner': PromoBannerBlock,
  'honeygain-components/info-card': InfoCardBlock,
  'honeygain-components/info-card-clickable': InfoCardBlock,
  'honeygain-components/info-card-compact': InfoCardCompactBlock,
  'honeygain-components/feature-card-row': FeatureCardRowBlock,
  'honeygain-components/clickable-feature-card-row': ClickableFeatureCardRowBlock,
  'honeygain-components/hello-bar': HelloBarBlock,
  'honeygain-components/carebuzz-hello-bar': HelloBarBlock,
  // LAYOUTS
  'honeygain-layouts/value-proposition': ValuePropositionBlock,
  'honeygain-layouts/value-proposition-list': ValuePropositionListBlock,
  'honeygain-layouts/component-list-item': ComponentListItemBlock,
  'honeygain-layouts/info-block-list': InfoBlockList,
  'honeygain-layouts/colored-background-layout': ColoredBackgroundLayoutBlock,
  'honeygain-layouts/hero-layout': HeroLayoutBlock,
  'honeygain-layouts/card-row': CardRowLayoutBlock,
  'honeygain-layouts/container': ContainerBlock,
  'honeygain-layouts/section': SectionBlock,
  'honeygain-layouts/two-side-layout': TwoSideLayoutBlock,
  'honeygain-layouts/background': BackgroundBlock,
  'honeygain-layouts/centered-blocks': CenteredBlocksListBlock,
  'honeygain-layouts/illustration-with-text': IllustrationWithTextLayoutBlock,
  'honeygain-layouts/hero-background': HeroBackgroundLayoutBlock,
  'honeygain-layouts/sequence-layout-item': SequenceLayoutItemBlock,
  'honeygain-layouts/sequence-layout': SequenceLayoutBlock,
  // SECTIONS
  'honeygain-sections/homepage-hero': HomepageHeroSectionBlock,
  'honeygain-sections/hero-v2': HeroBlock,
  'honeygain-sections/info-with-expandable-cards-v2': InfoWithExpandableCardsSectionBlockV2,
  'honeygain-sections/faq': FAQSectionBlock,
  'honeygain-sections/bottom-cta-v2': BottomCTASectionBlock,
  'honeygain-sections/cards-set': CardsSetBlock,
  'honeygain-sections/clickable-cards-set': CardsSetBlock,
  'honeygain-sections/feature-cards-set': FeatureCardsSetBlock,
  'honeygain-sections/clickable-feature-cards-set': ClickableFeatureCardsSetBlock,
  'honeygain-sections/info-with-image': withClientOnly(InfoWithImageBlock),
  'honeygain-sections/customer-reviews': withClientOnly(CustomerReviewsBlock),
  'honeygain-sections/faq-v2': FAQBlock,
  'honeygain-sections/steps': StepsBlock,
  'honeygain-sections/clickable-small-cards-set': ClickableSmallCardsBlock,
  'honeygain-sections/logos': LogosBlock,
  'honeygain-sections/video-reviews': VideoReviewsBlock,
  'honeygain-sections/promo': PromoBlock,
  'honeygain-sections/socials': SocialsBlock,
  'honeygain-sections/gallery': withClientOnly(GallerySectionBlock),
  'honeygain-sections/gallery-with-info': withClientOnly(GalleryWithInfoSectionBlock),
  'honeygain-sections/heading-with-context': HeadingWithContext,
  'honeygain-sections/heading-with-image': HeadingWithImage,
  'honeygain-sections/info-with-bullet-points': InfoWithBulletPointsBlock,
  'honeygain-sections/info-with-video-gallery': withClientOnly(InfoWithVideoGallerySectionBlock),
  'honeygain-sections/calculator': withClientOnly(CalculatorBlock),
  'honeygain-sections/stats': StatsBlock,
  'honeygain-sections/statistics': StatisticsBlock,
  'honeygain-sections/statistics-grid': StatisticsGridBlock,
  'honeygain-sections/testimonials': withClientOnly(TestimonialsBlock),
  'honeygain-sections/hero-centered': HeroCenteredBlock,
  'honeygain-sections/big-headline': BigHeadlineBlock,
  'honeygain-sections/popup': PopupBlock,
  // CORE
  'core/columns': WPGColumnsBlock,
  'core/shortcode': ShortcodeBlock,
  'core/group': GroupBlock,
  'core/image': WPGImageBlock,
  'core/list': WPGListBlock,
  'core/paragraph': WPGParagraphBlock,
  // UTILS
  'honeygain-typography/text': TextBlock,
  'honeygain-utils/signup-campaign': SignupCampaignBlock,
  'honeygain-utils/growthbook-experiment': GrowthbookExperimentBlock,
  'honeygain-utils/growthbook-variant': GrowthbookVariantBlock,
}

export const blogRegistry: Registry = {
  'core/list': BlogListBlock,
  'core/paragraph': BlogParagraphBlock,
  'core/heading': BlogHeadingBlock,
  'core/image': BlogImageBlock,
}

export const getCustomBlock = (name: string) => registry[name]

export const createCustomRegistryBlockGetter = (customRegistry: Registry) => (name: string) =>
  customRegistry?.[name] ?? registry[name]
